<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="我的信息" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card pb-16px">
        <el-descriptions title="基本信息" column="1">
          <el-descriptions-item label="公司名称">
            <p>{{ infoData.distributorName }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="邀请链接">
            <span>{{ inviteLink }} <el-copy :content="inviteLink" /></span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="jc-page-card pb-16px">
        <el-descriptions title="工商信息" column="1">
          <el-descriptions-item label="营业执照号">
            <p>{{ infoData.businessLicense }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="法定代表人">
            <span>{{ infoData.legalRepresentative }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="营业执照">
            <el-image
              v-if="infoData.businessLicensePicUri"
              style="width: 200px; height: 200px"
              :src="infoData.businessLicensePicUri"
              :preview-src-list="[infoData.businessLicensePicUri]"
            >
            </el-image>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="flex gap-16px">
        <div class="jc-page-card">
          <el-descriptions title="公司信息" column="1">
            <template #extra>
              <el-button type="primary" @click="modifyCompanyInfo"
                >修改</el-button
              >
            </template>
            <el-descriptions-item label="办公地址">
              <p>{{ infoData.workAddress }}</p>
            </el-descriptions-item>
            <el-descriptions-item label="联系人姓名">
              <span>{{ infoData.contracter }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="联系电话">
              <p>{{ infoData.tel }}</p>
            </el-descriptions-item>
            <el-descriptions-item label="邮箱">
              <p>{{ infoData.email }}</p>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="jc-page-card !mb-16px">
          <el-descriptions title="发票信息" column="1">
            <template #extra>
              <el-button type="primary" @click="modifyInvoiceInformation"
                >修改</el-button
              >
            </template>
            <el-descriptions-item label="公司名称">
              <p>{{ infoData.invoiceTitle }}</p>
            </el-descriptions-item>
            <el-descriptions-item label="纳税人识别号">
              <span>{{ infoData.taxNumber }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>

    <edit-company-info
      :infoData="infoData"
      ref="companyDialog"
      @submitSuccess="getInfo"
    ></edit-company-info>

    <edit-invoice-information
      :infoData="infoData"
      ref="invoice"
      @success="getInfo"
    />
  </div>
</template>

<script>
import { getFirstInfo } from '@/api/distributor-api'
import routerMixins from '@/mixins/router-mixins.js'
export default {
  props: [],
  components: {
    EditCompanyInfo: () => import('@/views/info/models/EditCompanyInfo.vue'),
    EditInvoiceInformation: () =>
      import('@/views/info/models/EditInvoiceInformation.vue'),
  },
  mixins: [routerMixins],
  data() {
    return {
      infoData: {},
      loading: false,
    }
  },
  computed: {
    inviteLink() {
      let { distributorId } = this.infoData
      if (!distributorId) {
        return ''
      }
      const { protocol, host } = window.location
      return `${protocol}//${host}/partner/notice/${distributorId}`
    },
  },
  async created() {
    await this.getInfo()
  },
  filters: {},
  methods: {
    async getInfo() {
      this.loading = true
      try {
        let {
          result: { distributorResult },
        } = await getFirstInfo()
        this.infoData = distributorResult
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    modifyCompanyInfo() {
      this.$refs.companyDialog.showDialog()
    },
    modifyInvoiceInformation() {
      this.$refs.invoice.showDialog()
    },
  },
}
</script>
